import * as React  from "react";
import { useState } from "react";
import axios from "axios";

const Edit = (props) => {
  const [groupName, setGroupName] = useState(props.m_company_group.name)
  const [groupId, setGroupId] = useState(props.m_company_group.group_id)

  const [selectedCompanies, setSelectedCompanies] = useState(props.selected_companies)
  const [unselectedCompanies, setUnselectedCompanies] = useState(props.unselected_companies)

  const [errorMessage, setErrorMessage] = useState("");

  const addSelectedCompanies = (companyId: number, companyName: string) => {
    let updateSelectedCompanies = [...selectedCompanies, { id: companyId, company_name: companyName }]
    setSelectedCompanies(updateSelectedCompanies)
    let updateUnselectedCompanies = unselectedCompanies.filter(company => company.id !== companyId)
    setUnselectedCompanies(updateUnselectedCompanies)
  }

  const addUnselectedCompanies = (companyId: number, companyName: string) => {
    let updateUnelectedCompanies = [...unselectedCompanies, { id: companyId, company_name: companyName }]
    setUnselectedCompanies(updateUnelectedCompanies)
    let updateSelectedCompanies = selectedCompanies.filter(company => company.id !== companyId)
    setSelectedCompanies(updateSelectedCompanies)
  }

  const onSubmit = () => {
    axios.post(`/api/internal/company_groups/update`,
    {
      m_company_group: {
        id: props.m_company_group.id,
        name: groupName,
        group_id: groupId,
        selected_companies: selectedCompanies,
        unselected_companies: unselectedCompanies
      }
    }).then(function () {
      location.href = ("/company_group/index");
    })
    .catch(error => {
      setErrorMessage(error.response.data.error)
    });
  }

  return (
    <>
      {errorMessage && 
      <div className="alert alert-danger alert-dismissible" role="alert">
        <button 
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="閉じる">
          <span aria-hidden="true">×</span>
        </button>{errorMessage}
      </div>}
      <h3>企業グループ編集</h3>
      <div className="container mt50">
        <div className="row">
          <div className="form-group col-md-5">
            <label>グループ名</label>
            <input
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              type="text"
              className="form-control col-lg-1"
              disabled={props.is_reader}></input>
          </div>
          <div className="form-group col-md-5">
            <label>グループID</label>
            <input
              value={groupId}
              onChange={(e) => setGroupId(e.target.value)}
              type="text"
              className="form-control col-lg-1"
              disabled={props.is_reader}></input>
          </div>
          <div className="form-group col-md-2">
            <button
              disabled={!groupId || !groupName || props.is_reader}
              onClick={() => onSubmit()}
              className="btn btn-primary btn-lg mt20">更新</button>
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-6 col-lg-6">
            <div>未選択企業</div>
            <ul className="list-group">
              {unselectedCompanies.map((company, i) => {
                return (
                  <li key={i} className="list-group-item">
                    <div className="row">
                      <div className="form-group col-md-9">
                        {company.company_name}
                      </div>
                      <div className="form-group col-md-3">
                        <button              
                          onClick={() => addSelectedCompanies(company.id, company.company_name)}
                          className="btn btn-primary" disabled={props.is_reader}>追加</button>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
          <div className="col-md-6 col-lg-6">
            <div>選択済み企業</div>
            <ul className="list-group">
              {selectedCompanies.map((company, i) => {
                return (
                  <li key={i} className="list-group-item">
                    <div className="row">
                      <div className="form-group col-md-9">
                        {company.company_name}
                      </div>
                      <div className="form-group col-md-3">
                        <button
                          onClick={() => addUnselectedCompanies(company.id, company.company_name)}
                          className="btn btn-danger" disabled={props.is_reader}>削除</button>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
        {/* ボタン類 */}
        <div>
          <div className="actions mt40">
              <a className="btn btn-primary pull-left m5" href="/company_group/index">戻る</a>
          </div>
        </div>
      </div>
    </>
  )
}

export default Edit
